import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntityTableRow, { EntityTableRowProps } from 'components/EntityTableRow';
import TableCell from 'components/TableCell';
import Price from 'components/FlightListPrice';
import LastPriceChange from 'components/FlightListLastPriceChange';
import LastUpdate from 'components/FlightListLastUpdate';
import Provider from 'components/FlightListProvider';
import FlightStatus from 'components/FlightStatus';
import FlightShortDetails from 'components/FlightShortDetails';

import { FlightListRow_flight$key } from '__generated__/FlightListRow_flight.graphql';

type Props = EntityTableRowProps & {
  flight: FlightListRow_flight$key;
};

const FlightListRow: FC<Props> = ({ flight, ...props }) => {
  const flightData = useFragment(
    graphql`
      fragment FlightListRow_flight on Flight {
        id
        createdAt
        provider

        ...EntityTableRow_entity
        ...FlightShortDetails_flight
        ...FlightListPrice_flight
        ...FlightListLastPriceChange_flight
        ...FlightListLastUpdate_flight
        ...FlightListProvider_flight
        ...FlightStatus_flight
      }
    `,
    flight
  );

  return (
    <EntityTableRow entity={flightData} {...props}>
      <TableCell sx={{ minWidth: '240px' }}>
        <FlightShortDetails flight={flightData} />
      </TableCell>

      <TableCell center>
        <Price flight={flightData} />
      </TableCell>

      <TableCell center>
        <LastPriceChange flight={flightData} />
      </TableCell>

      <TableCell center>{flightData.createdAt}</TableCell>

      <TableCell center>
        <LastUpdate flight={flightData} />
      </TableCell>

      <TableCell center>
        <Provider flight={flightData} sx={{ height: '20px' }} />
      </TableCell>

      <TableCell center>
        <FlightStatus flight={flightData} />
      </TableCell>
    </EntityTableRow>
  );
};

export default FlightListRow;
